import { useCallback, useEffect, useState } from 'react'
import { api } from '../../utils/api'

const NOT_FOUND = 404

/**
 * The boxes of one collection (Trac #1077 part 1, #1337): the read, and the
 * three writes. Every write is followed by a fresh read, so the screen only
 * shows what Prism holds.
 *
 * `parcels` is the GET answer, or null while loading, or when the collection has
 * no booking yet (`missing`). `error` is a message for any other failure.
 */
export function useCollectionParcels(dealId) {
  const [parcels, setParcels] = useState(null)
  const [missing, setMissing] = useState(false)
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)
  const [writeError, setWriteError] = useState(null)

  const reload = useCallback(async () => {
    try {
      setParcels(await api.get(`/api/deals/collections/${dealId}/parcels`))
      setMissing(false)
      setError(null)
    } catch (e) {
      if (e.status === NOT_FOUND) {
        setMissing(true)
        return
      }
      setError(e.message)
    }
  }, [dealId])

  useEffect(() => { reload() }, [reload])

  async function write(call) {
    setBusy(true)
    setWriteError(null)
    try {
      await call()
      await reload()
      return true
    } catch (e) {
      setWriteError(e.message)
      return false
    } finally {
      setBusy(false)
    }
  }

  const base = `/api/deals/collections/${dealId}/parcels`
  return {
    parcels,
    missing,
    error,
    busy,
    writeError,
    addBox: () => write(() => api.post(base, {})),
    setBoxItems: (boxNumber, itemIds) => write(() => api.put(`${base}/${boxNumber}/items`, { item_ids: itemIds })),
    setBoxLabel: (boxNumber, label) => write(() => api.put(`${base}/${boxNumber}/label`, label)),
  }
}
